import { CardFeatureList } from "Features/SubscriptionConfiguration/SubscriptionTiers/redux/types";

export const labelToKey = (label: string): string => {
  return label
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, "_")
    .replace(/^_+|_+$/g, "");
};

export const ensureUniqueKeys = (
  features: CardFeatureList[]
): CardFeatureList[] => {
  const keyCounts: { [key: string]: number } = {};
  return features.map((feature, index) => {
    let key = feature.key;
    if (keyCounts[key]) {
      keyCounts[key]++;
      key = `${key}_${keyCounts[key]}`;
    } else {
      keyCounts[key] = 1;
    }
    return { ...feature, key, order: feature.order ?? index };
  });
};
